import { RichText } from '@sitecore-jss/sitecore-jss-react';
import React, { FC } from 'react';
import { TSummarySpecsProps } from '../../types/seriesListing.types';

const SummarySpecs: FC<TSummarySpecsProps> = ({ summarySpecs }) => {
  return (
    <ul className="product-card__summary-specs">
      {summarySpecs.map(({ key, value }, index) => (
        <li className="product-card__summary-specs-item" key={`summary-spec-${index}`}>
          <RichText tag="div" className="product-card__summary-specs-headline rich-text" field={{ value: key }} editable={false} />
          <RichText tag="div" className="product-card__summary-specs-value rich-text" field={{ value: value }} editable={false} />
        </li>
      ))}
    </ul>
  );
};

export default SummarySpecs;
